import { fetchGet } from './fetch';
import { fetchPost } from './fetch';
import { AudioListResponse, AudioListV2Request } from './interface';
import { MarketAudioDto } from './type';
import { FilterGroup, StyleFilterArtistDetail, StyleFilterAnalytics } from './type/Filter';
import { Filter, Order } from './type/FilterDto';

const API_URL = '/api/v2/stylefilter';

export interface FilterListResponse {
  data?: Filter[];
  error?: {
    errorMessage: string;
    code: number;
  };
}

export interface FilterDetailResponse {
  data?: Filter;
  error?: {
    errorMessage: string;
    code: number;
  };
}

export interface FilterOrderRequest {
  orders: Order[];
}

export interface FilterOrderResponse {
  error?: {
    errorMessage: string;
    code: number;
  };
  sessionUrl?: string;
}

export interface FilterGroupListResponse {
  data?: FilterGroup[];
  error?: {
    errorMessage: string;
    code: number;
  };
}

export interface FilterGroupDetailResponse {
  data?: FilterGroup;
  error?: {
    errorMessage: string;
    code: number;
  };
}

export interface StyleFilterArtistDetailResponse {
  data?: StyleFilterArtistDetail;
  error?: {
    errorMessage: string;
    code: number;
  };
}

export interface StyleFilterAnalyticsResponse {
  data?: StyleFilterAnalytics;
  error?: {
    errorMessage: string;
    code: number;
  };
}

export interface StyleFilterArtistSFGenerationResponse {
  count?: number;
  data: MarketAudioDto[];
  error?: {
    errorMessage: string;
    code: number;
  };
}

export const getStyleFilterList = async (): Promise<FilterListResponse> => {
  const url = `${API_URL}/list`;
  return fetchGet<FilterListResponse>(url);
};

export const getPublicStyleFilterList = async (): Promise<FilterListResponse> => {
  const url = `${API_URL}/public_list`;
  return fetchGet<FilterListResponse>(url);
};

export const getStyleFilterGroupList = async (filter_purchased?: boolean): Promise<FilterGroupListResponse> => {
  const url = `${API_URL}/group_list?filter_purchased=${filter_purchased ? 'true' : 'false'}`;
  return fetchGet<FilterGroupListResponse>(url);
};

export const getStyleFilterGroupDetail = async (id: number): Promise<FilterGroupDetailResponse> => {
  const url = `${API_URL}/group_detail/${id}`;
  return fetchGet<FilterGroupDetailResponse>(url);
};

export const getStyleFilterGroupDetailByName = async (name: string): Promise<FilterGroupDetailResponse> => {
  const url = `${API_URL}/group_detail_by_name/${name}`;
  return fetchGet<FilterGroupDetailResponse>(url);
};

export const getStyleFilterArtistDetailByName = async (artist: string): Promise<StyleFilterArtistDetailResponse> => {
  const url = `${API_URL}/artist_detail_by_name/${artist}`;
  return fetchGet<StyleFilterArtistDetailResponse>(url);
};

export const getInternalStyleFilterList = async (): Promise<FilterListResponse> => {
  const url = `${API_URL}/internal_list`;
  return fetchGet<FilterListResponse>(url);
};

export const postStyleFilterOrder = async (req: FilterOrderRequest): Promise<FilterOrderResponse> => {
  const url = `${API_URL}/order`;
  return fetchPost<FilterOrderRequest, FilterOrderResponse>(url, req);
};

export const getStyleFilterDetail = async (id: number): Promise<FilterDetailResponse> => {
  const url = `${API_URL}/detail/${id}`;
  return fetchGet<FilterDetailResponse>(url);
};

export const getPublicAudioAllTracksV2 = async (
  queryParams?: AudioListV2Request & { stylefilter?: string },
): Promise<AudioListResponse> => {
  const url = `/api/v2/audio/all_tracks_public`;
  return fetchGet<AudioListResponse>(url, {}, queryParams);
};

export const getStyleFilterAnalytics = async (from?: string, to?: string): Promise<StyleFilterAnalyticsResponse> => {
  let url = `/api/v2/stylefilter/analytics`;
  if (from && to) {
    url = `${url}?from=${from}&to=${to}`;
  }
  return fetchGet<StyleFilterAnalyticsResponse>(url);
};

export const getStyleFilterArtistSFGeneration = async ({
  page,
  pageSize,
  styleFilterGroupId,
  stylefilterId,
}: {
  page: number;
  pageSize: number;
  styleFilterGroupId: number;
  stylefilterId: number;
}): Promise<StyleFilterArtistSFGenerationResponse> => {
  const url = `/api/v2/stylefilter/artist_sf_generation?page=${page}&pageSize=${pageSize}&stylefilterGroupId=${styleFilterGroupId}&stylefilterId=${stylefilterId}`;
  return fetchGet(url);
};

export const getStyleFilterArtistDetail = async (id: string) => {
  const url = `/api/v2/stylefilter/artist_detail/${id}`;
  return fetchGet<StyleFilterArtistDetailResponse>(url);
};

// export const getStyleFilterDetail = async (id: string) => {
//   const url = `/api/v2/stylefilter/detail/${id}`;
//   return fetchGet<StyleFilterDetailResponse>(url);
// };
